import { Component, Input } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AccountBaseService } from '../account-base-service';
import { AutocompleteComponent } from '../../ui/autocomplete/autocomplete.component';
import { AccountHintData } from '../account.model';
import { ProductCode } from '../../product/product.model';

@Component({
    selector: 'ifc-account-application-number-input',
    templateUrl: '../../ui/autocomplete/autocomplete.component.html',
    styleUrls: ['../../ui/autocomplete/autocomplete.component.css'],
    standalone: false
})
export class AccountApplicationNumberInputComponent extends AutocompleteComponent {

  @Input()
  productCode: ProductCode;

  @Input()
  excludedProductCode: ProductCode;

  constructor(private accountService: AccountBaseService) {
    super();
  }

  label = 'Application number';

  optionFilter: (input: string | AccountHintData) => Observable<any[]> =
    input => input
      ? this.accountService.queryHints({
        applicationNumber: !!input ? (typeof input !== 'string' ? input.applicationNumber : input) : null,
        productCode: this.productCode,
        excludedProductCode: this.excludedProductCode,
        sortField: 'applicationNumber'
      })
      : EMPTY;

  optionLabelKey = 'applicationNumber';
}
